const createEnum = <T extends string>(...values: readonly T[]): { [P in T]: P } =>
  values.reduce((result, value) => {
    result[value] = value;

    return result;
  }, {} as any);

export { createEnum };
